import {FC} from 'react'
import {Link} from 'react-router-dom'
import { useIntl } from 'react-intl'

const Error403: FC = () => {
  const intl = useIntl()
  return (
    <>
      <div className='fw-semibold fs-2 text-gray-500 mb-7'>{intl.formatMessage({id: `general.error_page.403`})}</div>
      <div className='mb-0'>
        <Link to='/' className='btn btn-sm btn-primary'>
          {intl.formatMessage({id: `general.return_home`})}
        </Link>
      </div>
    </>
  )
}

export {Error403}
